<template>
  <form>
    <ToastMessage/>
    <website ref="website"/>
    <div style="width: 100%;">
      <div class="name">
        <div class="col-sm-6">
          <Galleria :value="this.images" :responsiveOptions="responsiveOptions2" thumbnailsPosition="right"
                    :numVisible="4" :showIndicators=false style="max-width:100%;width: 90%;"
                    :showItemNavigators="true" :showItemNavigatorsOnHover="true">
            <template #item="slotProps">
              <img :src="slotProps.item.name" :alt="slotProps.item.name" style="width: 98%; display: block;"/>
            </template>
            <template #thumbnail="slotProps" v-if="this.images.length>1">
              <div class="p-grid p-nogutter p-justify-center" >
                <img :src="slotProps.item.name" :alt="slotProps.item.name" style="display: block;width: 100%;"/>
              </div>
            </template>

          </Galleria>


        </div>
        <div class="col-sm-6">
          <h1 class="product-single__title">
            {{ this.itemName }}
          </h1>
          <div class="prInfoRow"></div>
          <p class="product-single__price product-single__price-product-template">
            <span class="product-price__price product-price__price-product-template">
                  <span class="money bacurr-money"><b>Nrs. {{ this.sellingPrice }}</b></span>
                </span>
          </p>
          <br/>
          <label>SIZE: <b>{{ this.selectedSize }}</b></label>
          <SelectButton v-model="selectedSize" :options="options"/>
          <label class="slVariant p-mt-2">FABRIC: <b>COTTON BLEND</b></label>
          <Button label="COTTON BLEND" class="p-button-outlined "/>
          <label class="p-mt-2 infolinks">SIZE GUIDE:</label>
          <div class="p-grid">
            <div class="p-col-12 p-md-6 p-lg-3">
              <Button icon="pi pi-minus" class="p-button-secondary p-button-text" @click.prevent="deductQty"/>
              <InputText class="p-col-6" v-model="qty"/>
              <Button icon="pi pi-plus" class="p-button-secondary p-button-text" @click.prevent="addQty"/>
            </div>
            <div class="p-col-12 p-md-9 p-lg-9" style=" margin-left: -.5em;">
              <Button label="ADD TO CART" class="p-button-warning p-lg-12" @click.prevent="addToCart"/>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-12">
            <Button label="BUY IT NOW" class="p-button-info p-lg-12"/>
          </div>

          <div class="p-grid p-mt-5">
            <div class="p-col-fixed" style="width:150px">
              <span class="pi pi-heart" style="font-size: 16px">View Wishlist</span>
            </div>
            <div class="p-col"></div>
            <div class="p-col">
              <span class="pi pi-facebook p-ml-2" style="font-size: 16px;"/>
              <span>Share</span>
              <span class="pi pi-twitter p-ml-2" style="font-size: 16px"/>
              <span>Tweet</span>
              <span class="pi pi-envelope p-ml-2" style="font-size: 16px"/>
              <span>Email</span>
            </div>
          </div>
          <div class="p-col p-mt-5">
            <span class="pi pi-shopping-cart" style="font-size: 16px;"></span>
            <span class="p-ml-2">Your order is eligible for FREE Delivery.</span>
          </div>
          <div class="p-col">
            <span class="pi pi-clock" style="font-size: 16px;"></span>
            <span class="p-ml-2">Estimated delivery between Wed. Sep 29 and Tue. Oct 5.</span>
          </div>
          <div class="p-col ">
            <span class="pi pi-users " style="font-size: 16px;color: red"></span>
            <span class="p-ml-2"><span style="color: red">43</span> Other parents looking for this product</span>
          </div>
        </div>

      </div>

      <br/>
         <br/>
            <br/>
      <div class="tabs-listing wow fadeIn" style="visibility: visible; animation-name: fadeIn;">
        <TabView>
          <TabPanel header="PRODUCT DETAILS " style="color: #141415;border-color: #1b1c1d;" class="active">
            <p class="tab-content" style="color: #141415;border-color: #1b1c1d;">{{ this.description }}</p>
          </TabPanel>
          <TabPanel header="PRODUCT REVIEW">
            <p>Very High Quality Loved It</p>
          </TabPanel>
          <TabPanel header="EXCHANGE & CANCELLATIONS">

            <h5>How do I Cancel or Exchange?</h5>
            <p>
              Drop an Email on talk.lilpicks@gmail.com or whatsApp on 9911437000
            </p>

            <p>
              What items are non-exchangeable?
              You can exchange your items within 15 days of receipt of your shipment.
            </p>

            <p>
              They must be in original condition
            </p>
            Must be unwashed and unworn
            <p/>
            In the original packaging
            <p/>
            Free gifts or promotional items are non-exchangeable !
            <p/>
            <h5>
              Are there any charges for exchange?
            </h5>

            There are no charges for exchange.
            <p/>
            <h5>
              How soon will I get my exchange product?
            </h5>
            Once your return is received and inspected, we will send you an email to notify you that we have received
            your returned item. We will also notify you of the approval or rejection of your exchange. If you are
            approved, then your exchange
            <p/>
            will be processed, and mention your exchange items on mail or whatsApp. We will dispatch your product within
            2-3 days.
          </TabPanel>
        </TabView>
      </div>

      <br/>
       <br/>
        <br/>
           <br/>
              <br/>
      <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">
        <h2 class="section-header__title text-center h2">RELATED PRODUCTS</h2>
      </div>

      <div class="card">
        <Carousel :value="displayItemList" :numVisible="4" :numScroll="1" :responsiveOptions="responsiveOptions"
                  :circular="true" :autoplayInterval="3000">
          <template #item="slotProps">
            <div style="border-bottom: 0px solid #c8c8c8;">
              <div class="productList">
                <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
                  <div class="grid-view-item style1 wow fadeIn">
                    <div class="grid-view_image">
                      <a href="">
                        <img @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl"
                             :alt="slotProps.data.name" style="height: 365px;width: 75%;"/></a>
                      <div style="margin: 2% 0%;" class="grid-view-item__title">{{ slotProps.data.name }}</div>
                      <span class="product-price__price">Nrs.{{ slotProps.data.salesRate }}</span>
                      <div class="product-description">{{ slotProps.data.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Carousel>
      </div>
      <br/>
      <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">
        <h2 class="section-header__title text-center h2">RECENTLY VIEWED PRODUCT</h2>
      </div>
      <div class="card">
        <DataView :value="displayItemList" :paginator="true" class="grid grid--uniform grid-products grid--view-items"
                  style="width: 100%" :rows="4" :layout="layout">
          <template #grid="slotProps">
            <div class="p-col-12 p-md-3" style="border-bottom: 0px solid #c8c8c8;">
              <div class="productList">
                <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
                  <div class="grid-view-item style1 wow fadeIn">
                    <div class="grid-view_image">
                      <a href="">
                        <img @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl"
                             :alt="slotProps.data.name" style="height: 365px;width: 75%;"/></a>
                      <div style="margin: 2% 0%;" class="grid-view-item__title">{{ slotProps.data.name }}</div>
                      <span class="product-price__price">Nrs.{{ slotProps.data.salesRate }}</span>
                      <div class="product-description">{{ slotProps.data.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </DataView>

      </div>
    </div>

    <footerWebsite ref="footerWebsite"/>
  </form>
</template>
<script>
import Button from 'primevue/button'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Dialog from 'primevue/dialog'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
import Galleria from 'primevue/galleria'
import InputNumber from 'primevue/inputnumber'
import SelectButton from 'primevue/selectbutton'
import DataView from 'primevue/dataview'
import Carousel from 'primevue/carousel'
import InputText from 'primevue/inputtext'
import ToastMessage from 'primevue/toast'

export default {
  name: 'productDetail',
  props: ['productObject'],
  data() {
    return {
      itemName: '',
      sellingPrice: 0,
      description: '',
      id: 0,
      itemCode: 0,
      layout: 'grid',
      groupName: '',
      manufactureDate: '',
      displayItemList: [],
      selectedSize: '',
      qty: 1,
      productDetails: {},
      images: null,
      cartList: [],
      options: ['2-3Y', '3-4Y', '4-5Y'],
      responsiveOptions: [
        {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
        },
        {
          breakpoint: '600px',
          numVisible: 2,
          numScroll: 2
        },
        {
          breakpoint: '480px',
          numVisible: 1,
          numScroll: 1
        }
      ],
      responsiveOptions2: [
        {
          breakpoint: '768px',
          numVisible: 3
        },
        {
          breakpoint: '560px',
          numVisible: 1
        }
      ]
    }
  },
  mounted() {
    this.itemsList()
  },
  created() {
    this.searchInventoryInDetail()
  },
  methods: {
    async searchInventoryInDetail() {
      if (this.productObject === undefined) {
        this.id = this.$route.query.item
        let response = await this.$store.dispatch('loadItemMasterByItemId', this.id)
        this.productDetails = response.data.data
        this.itemName = response.data.data.name
        this.sellingPrice = response.data.data.salesRate
        this.description = response.data.data.description
        this.id = response.data.data.id
        this.itemCode = response.data.data.itemCode
        this.groupName = response.data.data.groupName
        this.images = response.data.data.imageList
      } else {
        this.itemName = this.productObject.itemName
        this.sellingPrice = this.productObject.sellingPrice
        this.description = this.productObject.description
        this.id = this.productObject.id
        this.itemCode = this.productObject.itemCode
        this.groupName = this.productObject.groupName
        this.images = this.productObject.images
      }
    },
    async viewProductDetailsPage(data) {
      let PIHdata = {
        id: data.id,
        itemName: data.name,
        imgUrl: data.singleImageUrl,
        sellingPrice: data.salesRate,
        description: data.description,
        itemCode: data.itemCode,
        groupName: data.groupName,
        images: data.imageList
      }
      this.$router.push({name: 'Product Detail', params: {productObject: PIHdata}, query: {item: PIHdata.id}})
    },
    async itemsList() {
      let response = await this.$store.dispatch('loadItemMasterListFeatured')
      this.displayItemList = response.data.data
    },
    addToCart() {
      if (this.qty === '0' || this.qty === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0', life: 3000})
        return
      }
      let item = {
        quantity: this.qty,
        size: this.selectedSize,
        item: this.productDetails
      }
      this.cartList.push({...item})
    },
    deductQty() {
      if (this.qty > 1) {
        this.qty = parseFloat(this.qty) - 1
      }
    },
    addQty() {
      this.qty = parseFloat(this.qty) + 1
    }
  },
  components: {
    Button,
    Dialog,
    Galleria,
    website,
    footerWebsite,
    InputNumber,
    SelectButton,
    TabView,
    TabPanel,
    DataView,
    Carousel,
    InputText,
    ToastMessage
  }
}
</script>
<style scoped src="@../../../static/css/website.css">
</style>



// WEBPACK FOOTER //
// productDetails.vue?6f637006